export default __webpack_public_path__ + "static/media/szafy1.33549102.jpg";